import { Typography } from 'gu-ui-kit'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import RecoverPasswordForm from 'modules/Forms/Auth/RecoverPassword'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

const Activation = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const pathGen = useGeneratePathI18n()

  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::recover_password.title')}</title>
      </Helmet>
      <Typography
        className={'margin-bottom-40'}
        component={'h1'}
        variant={'Body-Accent-40'}
        color={'Label-Fifth'}
      >
        {t('auth::recover_password.title')}
      </Typography>

      <RecoverPasswordForm
        onClose={() => history.push(pathGen(ROUTES.AUTH_LOGIN))}
      />
    </>
  )
}

export default Activation
